module.exports = __webpack_public_path__ + "static/fonts/NotoSansCJKkr-Light.87f51d2.woff";